
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"13","height":"16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.667.667h-8C.933.667.333 1.267.333 2v9.333h1.334V2h8V.667zm2 2.666H4.333C3.6 3.333 3 3.933 3 4.667V14c0 .733.6 1.333 1.333 1.333h7.334c.733 0 1.333-.6 1.333-1.333V4.667c0-.734-.6-1.334-1.333-1.334zm0 10.667H4.333V4.667h7.334V14z"}})])
      }
    
      }
    